import { ClientDataView } from "@avenueops/shared-types";
import { CopyAction } from "components/CopyableField";
import SelectorListItem from "components/generic-building-blocks/SelectorListItem";
import React from "react";

interface Props {
  dataView: ClientDataView;
}

export default function DataViewSelectorListItem({ dataView }: Props): JSX.Element {
  return (
    <div className="h-full flex flex-grow">
      <SelectorListItem
        title={dataView.title!}
        description={dataView.description!}
        explainer={`Unique IDs: [${dataView.idColumns.join(", ")}]`}
        user={dataView.user}
        tag={dataView.connection?.displayName!}
        updatedAt={dataView.updatedAt}
      />
      <div className="flex justify-center items-center px-2">
        <CopyAction
          onCopyText="Copied SQL Query!"
          copyValue={dataView.query ?? ""}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        />
      </div>
    </div>
  );
}
